import { IModal } from '@ibiz-template/runtime';
import { useNamespace } from '@ibiz-template/vue3-util';
import { defineComponent, PropType } from 'vue';
import './print-pdf.scss';

export const PrintPdf = defineComponent({
  name: 'PrintPdf',
  props: {
    modal: {
      type: Object as PropType<IModal>,
      required: true,
    },
    filename: {
      type: String,
      default: '',
    },
    images: {
      type: Array as PropType<IData[]>,
      default: () => [],
    },
  },
  setup() {
    const ns = useNamespace('print-pdf');

    return { ns };
  },
  render() {
    return (
      <div class={this.ns.b()}>
        <div class={this.ns.e('header')}>{this.filename}</div>
        <div class={this.ns.e('content')}>
          {this.images.map((item: IData) => (
            <div class={this.ns.e('item')}>
              <img src={item.base64} />
              {item.base642 ? <img src={item.base642} /> : null}
            </div>
          ))}
        </div>
      </div>
    );
  },
});
